module.exports = __webpack_public_path__ + "static/media/icon-error.8bd62c7c.svg";